"use strict";

var _interopRequireWildcard = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.map.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _SingleImage = _interopRequireDefault(require("@/components/Upload/SingleImage.vue"));
var _vuePropertyDecorator = require("vue-property-decorator");
var news = _interopRequireWildcard(require("@/api/news"));
var _index = _interopRequireDefault(require("@/components/Tinymce/index.vue"));
var _building = require("@/api/building.api");
var NewsModal = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(NewsModal, _Vue);
  var _super = (0, _createSuper2.default)(NewsModal);
  function NewsModal() {
    var _this;
    (0, _classCallCheck2.default)(this, NewsModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dialogVisible", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "formData", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "status", "create");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dialogStatus", "create");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "submitLoading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {
      title: {
        required: true,
        trigger: "submit",
        message: "Vui lòng nhập tiêu đề"
      },
      thumbnail: {
        required: true,
        trigger: "submit",
        message: "Bắt buộc"
      },
      body: {
        required: true,
        trigger: "submit",
        message: "Bắt buộc"
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dialogLoading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cities", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "districts", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wards", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildings", []);
    return _this;
  }
  (0, _createClass2.default)(NewsModal, [{
    key: "created",
    value: function created() {}
  }, {
    key: "handleUploadSuccess",
    value: function handleUploadSuccess(path) {
      debugger;
      this.$set(this.formData, "thumbnail", path);
    }
  }, {
    key: "setBody",
    value: function setBody() {
      this.$refs.editor.setContent(this.formData.body);
    }
  }, {
    key: "createData",
    value: function createData() {
      var _this2 = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this2.submitLoading = true;
          var data = {
            news: _this2.formData,
            buildingIds: _this2.formData.buildingIds
          };
          news.create(data).then(function () {
            _this2.$notify({
              title: "Thông báo",
              message: "Thêm tin tức thành công",
              type: "success"
            });
            _this2.$emit("submit:ok");
            _this2.dialogVisible = false;
          }).finally(function () {
            _this2.submitLoading = false;
          });
        }
      });
    }
  }, {
    key: "updateData",
    value: function updateData() {
      var _this3 = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this3.submitLoading = true;
          var data = {
            news: _this3.formData,
            buildingIds: _this3.formData.buildingIds
          };
          news.update(_this3.formData.id, data).then(function (res) {
            if (res.status) {
              _this3.$notify({
                title: "Thông báo",
                message: "Cập nhật tin tức thành công",
                type: "success"
              });
              _this3.$emit("submit:ok");
              _this3.dialogVisible = false;
            }
          }).finally(function () {
            _this3.submitLoading = false;
          });
        }
      });
    }
  }, {
    key: "handleUpdate",
    value: function () {
      var _handleUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(data) {
        var _data$buildings,
          _this4 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.dialogVisible = true;
                this.dialogStatus = "update";
                this.formData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
                  buildingIds: (_data$buildings = data.buildings) === null || _data$buildings === void 0 ? void 0 : _data$buildings.map(function (e) {
                    return e.id;
                  })
                });
                this.$nextTick(function () {
                  if (_this4.$refs.editor.hasInit) {
                    _this4.$refs["editor"].setContent(_this4.formData.body);
                  }
                });
                this.fetchBuilding();
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function handleUpdate(_x) {
        return _handleUpdate.apply(this, arguments);
      }
      return handleUpdate;
    }()
  }, {
    key: "handleCreate",
    value: function () {
      var _handleCreate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this5 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.dialogVisible = true;
                this.dialogStatus = "create";
                this.formData = {};
                this.$nextTick(function () {
                  _this5.$refs["form"].clearValidate();
                  if (_this5.$refs.editor.hasInit) {
                    _this5.$refs["editor"].setContent("");
                  }
                });
                this.fetchBuilding();
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function handleCreate() {
        return _handleCreate.apply(this, arguments);
      }
      return handleCreate;
    }()
  }, {
    key: "fetchBuilding",
    value: function () {
      var _fetchBuilding = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _building.buildingApi.findAll({
                  page: 0,
                  limit: 0
                });
              case 3:
                res = _context3.sent;
                this.buildings = res.data.buildings;
              case 5:
                _context3.prev = 5;
                return _context3.finish(5);
              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0,, 5, 7]]);
      }));
      function fetchBuilding() {
        return _fetchBuilding.apply(this, arguments);
      }
      return fetchBuilding;
    }()
  }]);
  return NewsModal;
}(_vuePropertyDecorator.Vue);
NewsModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    SingleImage: _SingleImage.default,
    Tinymce: _index.default
  }
})], NewsModal);
var _default = NewsModal;
exports.default = _default;